import { AttendeesTableColumns, SortOrder } from '../../Utils/Constants';
export const GET_SESSION_ATTENDEES_REQUEST = 'GET_SESSION_ATTENDEES_REQUEST';
export const GET_SESSION_ATTENDEES_SUCCESS = 'GET_SESSION_ATTENDEES_SUCCESS';
export const GET_SESSION_ATTENDEES_FAILURE = 'GET_SESSION_ATTENDEES_FAILURE';

const defaultFilter = {
  textSearch: ''
};

const defaultSort = { sortBy: AttendeesTableColumns.INTEREST_RATING, sortOrder: SortOrder.DESC };

export function getSessionAttendeesDetails(sessionKey, pageNumber = 0, filter = defaultFilter, sort = defaultSort) {
  return {
    type: GET_SESSION_ATTENDEES_REQUEST,
    payload: { sessionKey, pageNumber, filter, sort }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionAttendees/SessionAttendeesActions.js